import { render, staticRenderFns } from "./approveTicket.vue?vue&type=template&id=52f8db7f&lang=pug"
import script from "./approveTicket.vue?vue&type=script&lang=js"
export * from "./approveTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports